import React from "react"
import Components from "../index"

import { blokType } from "../../types"
import { StyledGrid, StyledGridProps } from "./partials"

export interface GridProps extends StyledGridProps {
  item: blokType[]
  microdata: boolean
}

export const GridCmp: React.FC<GridProps> = ({
  columns_wide,
  columns_desktop,
  columns_tablet,
  columns_mobile,
  gutters_wide,
  gutters_desktop,
  gutters_tablet,
  gutters_mobile,
  item,
  microdata,
}) => (
  <StyledGrid
  data-name="grid"
    gutters_wide={gutters_wide}
    gutters_desktop={gutters_desktop}
    gutters_tablet={gutters_tablet}
    gutters_mobile={gutters_mobile}
    columns_wide={columns_wide}
    columns_desktop={columns_desktop}
    columns_tablet={columns_tablet}
    columns_mobile={columns_mobile}
  >
    {item &&
      item.map((content: blokType) =>
        React.createElement(Components(content.component), {
          key: content._uid,
          blok: content,
          microdata: microdata, 
        })
      )}
  </StyledGrid>
)
